import common from "./ru-RU/common"
import home from "./ru-RU/home"
import query from './ru-RU/query'
import track from './ru-RU/track'
import contact from './ru-RU/contact'
import about from './ru-RU/about'

export default {
    ...common,
    ...home,
    ...about,
    ...query,
    ...track,
    ...contact
}